import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSalespersonLookup extends Layout {
    sourceSalesPerson: DataSource;
    tableSalesPerson: Table;
}
